import React from 'react';

const ShipmentFiltersContext = React.createContext({
  shipmentEventFilters: [],
  availableShipmentStates: [],
  carrierIntegrations: [],
  metadataGroupings: [],
  customEventTypes: [],
  smartFilterConfiguration: {},
  shipmentFilterExpiries: [],
  shipmentFiltersUdpated: false,
  availableCalculatedEvents: [],
  setShipmentFiltersUpdated: () => {},
});

export default ShipmentFiltersContext;
